import React, { useState, useEffect } from "react";
import "../style/measurementSearch.scss";
import Title from './common/Title';
import measureImage from "../common/images/MeasurementImage.svg";
import { dataLoader } from "@unbxd-ui/unbxd-react-components";
import searchIcon from "../common/images/search_icon.png";
import utils from "../common/utils";

export default function MeasurementSearch() {
    const [ query, setQuery ] = useState("Glasses under 10$");
    const [ data, setData ] = useState(null);
    const [ dimensions, setDimensions ] = useState({});
    const [ isLoading, setIsLoading ] = useState(false);
    const sampleQueries = [
        'Glasses under 10$',
        '3 kg potato',
        '10 inch foam mattress',
        'sandals size 34 cm, 35cm',
        'bulb 15 volt'
    ]
    const [ selectedTag, setSelectedTag ] = useState(sampleQueries[ 0 ]);
    const [ error, setError ] = useState("");

    useEffect(() => {
        sendApiRequest(null, "Glasses under 10$");
    }, []);

    const validate = (val) => {
        if (val.length === 0) {
            setError("Input cannot be empty");
            return false;
        } else {
            setError("");
            return true;
        }
    }

    const onInputChange = (e) => {
        setQuery(e.target.value);
    }

    const sendApiRequest = (event, value) => {

        if (validate(value || query)) {
            setIsLoading(true);
            let def = dataLoader.getRequestDef({
                requestId: 'getMeasurementData',
                params: {
                    query: value || query
                }
            })

            def.done(response => {
                setError("");
                setIsLoading(false);
                const { data = {}, errors = [] } = response;
                const { dimensions = {} } = data;

                if (errors && errors.length) {
                    //setError here
                    return;
                }

                setData(data);
                setDimensions(dimensions);
            })

            def.catch((error) => {
                setError(error);
                setIsLoading(false);
                console.log(error);
            });
        }
    }

    const onQueryBadgeClick = (que) => {
        setSelectedTag(que);
        setQuery(que);
        sendApiRequest(null, que);
    }

    return (
        <div className="columns highlight-info sticky-hexagon">
            <div className="column col-xl-12 col-7 last-xl">
                <div className="content-wrap">
                    <div className="measurement-left-section">
                        <img src={measureImage} className="ms-demo-img" />
                        {!error && !isLoading && Object.keys(dimensions).length > 0 ?
                            <div className="ner-results-table text-center">
                                <div className="demo-table-header columns">
                                    <div className="column">Dimensions</div>
                                    <div className="column">Identified Value</div>
                                    <div className="column">Normalized Value</div>
                                </div>
                                {Object.keys(dimensions).length && Object.keys(dimensions).map(record => {
                                    return (
                                        <>
                                            {dimensions[ record ].length ? <div className="demo-table-data columns">
                                                <div className="column">{utils.capitalize(record.toLowerCase())}</div>
                                                <div className="column">
                                                    {dimensions[ record ].length && (dimensions[ record ].map(rec => {
                                                        return rec.text;
                                                    })).join(", ")}
                                                </div>
                                                <div className="column">
                                                {dimensions[ record ].length && (dimensions[ record ].map(rec => {
                                                    const {condition, minValue, maxValue, units} = rec;
                                                        if(condition === "RANGE"){
                                                            return minValue + " - " + maxValue + " " + units;
                                                        } else if(condition === "EQUAL"){
                                                            return (minValue * 0.9).toFixed(2) + " - " + (maxValue * 1.1).toFixed(2) + " " + units.toLowerCase();
                                                        }
                                                       
                                                    })).join(", ")}
                                                </div>
                                            </div> :
                                                ""}
                                        </>
                                    )
                                })}
                            </div> : ""
                        }
                        {isLoading && <img className="ms-loading-icon" src={"/images/blueLoader.svg"} />}
                    </div>
                </div>
            </div>

            <div className="column col-xl-12 col-5 highlight-content-right first-xxl">
                <div className="content-wrap">
                    <div className="measure-results-wrapper">
                        <Title title="Measurement Search" className="mb-2 sub-title title" />
                        <div className="feature-description desc col-xl-12 col-12">We can identify, convert, and refine the results for search queries with numeric values like Currency, Date, Size, Time, Weight, Pressure, and Information/Storage.</div>
                        <div className="spin">Try Your Query</div>

                        <div className="search-container">
                            <div className="search-input-container">
                                <input type="text" value={query} placeholder="Enter A Query" className="search-input" onChange={onInputChange} />
                                <img src={searchIcon} className="search-img" />
                            </div>
                            <button onClick={sendApiRequest} className="search-button">Preview</button>
                        </div>
                        {error && <div className="api-error entity-extraction">{error}</div>}
                        <div className="spin">Try Sample Queries</div>
                        <div className="sample-queries-container">
                            {sampleQueries.map(que => {
                                return <span className={`sample-queries-tags ${selectedTag === que ? 'sample-query-highlight' : ""}`} onClick={onQueryBadgeClick.bind(null, que)}>{que}</span>
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
